import React from 'react';
import './PrivacyPolicy.css';
import { useLocalContext } from '../../context/LocalContext';

const PrivacyPolicy = () => {
  const { webinfo } = useLocalContext();

  return (
    <section className="policy-wrapper">
      <div className="policy-header">
        <h1>Privacy Policy</h1>
        <p>
          Your privacy is important to us. This policy explains how <strong>{webinfo.name}</strong> collects, uses, shares, and protects your personal information.
        </p>
      </div>

      <div className="policy-content">
        <div className="policy-section">
          <h2>1. Introduction</h2>
          <p>
            <strong>{webinfo.name}</strong> is committed to protecting your personal data. This policy outlines the types of data we collect, how we use it, and your rights regarding that data.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Data We Collect</h2>
          <ul>
            <li><strong>Contact Information:</strong> Name, email, phone, and business name.</li>
            <li><strong>Usage Data:</strong> IP address, browser type, device info, page visits, and referral sources.</li>
            <li><strong>Marketing Data:</strong> Your communication preferences and form submissions.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. How We Use Your Data</h2>
          <ul>
            <li>To respond to your inquiries and provide services you request.</li>
            <li>To improve website performance, functionality, and user experience.</li>
            <li>To send updates, offers, and relevant communications (only with consent).</li>
            <li>To comply with applicable laws and protect our legal rights.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Use of Cookies</h2>
          <p>
            We use cookies and analytics tools like Google Analytics and Meta Pixel to track usage patterns and improve our content. You can control cookie settings in your browser.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. Data Security</h2>
          <p>
            Your data is stored securely on encrypted servers and accessed only by authorized personnel. While we follow best practices, no system is 100% secure.
          </p>
        </div>

        <div className="policy-section">
          <h2>6. Your Privacy Rights</h2>
          <ul>
            <li>Access the personal data we hold about you.</li>
            <li>Request corrections or deletion of your data.</li>
            <li>Opt out of marketing emails at any time.</li>
            <li>File a complaint with your data protection authority.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>7. Sharing Your Information</h2>
          <p>
            We may share your data with our trusted vendors and partners (e.g., CRM providers, hosting platforms) to fulfill our services. We never sell your personal data.
          </p>
        </div>

        <div className="policy-section">
          <h2>8. Data Retention</h2>
          <p>
            We keep your data only for as long as it’s necessary for service delivery, analytics, legal, or operational reasons. You may request earlier removal by contacting us.
          </p>
        </div>

        <div className="policy-section">
          <h2>9. Policy Updates</h2>
          <p>
            We may revise this policy to reflect changes in our practices or legal requirements. Updates will be published on this page with the new effective date.
          </p>
        </div>

        <div className="policy-section">
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions or concerns, please reach us at <a href={`mailto:${webinfo.email}`}>{webinfo.email}</a> or call <strong>{webinfo.phone}</strong>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
